export default "__VITE_ASSET__59cb19e9__"